import base from '../base'
import { getRequest, postJsonRequest, blobJsonRequest } from '@utils/request'
const cloud = `prescription/${base.appCode}`
const ERPCHARGEBACK = {
// 获取列表(分页)
  erpChargebackList(params = {}) {
    console.log('~~~~~~', `${base.baseUrl}/${cloud}/api/busiPush/list`)
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/busiPush/list`, params)
  },
  // 获取药商列表(分页)
  erpChargebackList1(params = {}) {
    // params.query.appCode = base.appCode
    return getRequest(`${base.baseUrl}/${cloud}/api/busiPush/list`, params)
  },
  // 获取药商列表(分页)
  erpChargebackList2(params = {}) {
    // params.query.appCode = base.appCode
    return blobJsonRequest(`${base.baseUrl}/${cloud}/api/busiPush/list`, params)
  }
}

export default ERPCHARGEBACK



// WEBPACK FOOTER //
// ./src/api/modules/erpchargeback.js